module.exports = __webpack_public_path__ + "static/media/android_en.1dd4ec35.svg";